import type { ROLE } from "../../persistence";

export default (role: ROLE, allowedRoles: ROLE[]): boolean | null => !allowedRoles.includes(role);
